import getControlSchemaProperty from '../../Shared/jsonSchemaUtilities/getControlSchemaProperty';
import PageState from '../../Shared/pageState';

export const resetConditionalControls = (pages: PageState[]): PageState[] => {
  return pages.map((page) => {
    for (const control of page.controls) {
      const isConditional = getControlSchemaProperty(
        control,
        'conditional'
      ) as boolean;
      if (isConditional) {
        control.visible = false;
      }
    }
    return page;
  });
};
